export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
export const SET_VALIDITY = "SET_VALIDITY";
export const SET_TOTAL = "SET_TOTAL";
export const SET_CAN_USE_KI_PILOT_THEORY = "SET_CAN_USE_KI_PILOT_THEORY";
export const SET_YOUTUBE_LINK = "SET_YOUTUBE_LINK";
export const SET_PRAXIS_OVERVIEW = "SET_PRAXIS_OVERVIEW";
export const SET_EXPLANATION_LOADING = "SET_EXPLANATION_LOADING";
export const SET_EXPLAIN_VOLUME = "SET_EXPLAIN_VOLUME";
export const SET_EXPLAIN_PRE_EXAM_PERFORMANCE = "SET_EXPLAIN_PRE_EXAM_PERFORMANCE";
export const SET_EXPLAIN_PERFORMANCE = "SET_EXPLAIN_PERFORMANCE";
export const SET_EXPLAIN_GENERAL_OVERVIEW = "SET_EXPLAIN_GENERAL_OVERVIEW";
export const SET_EXPLAIN_CATEGORY = "SET_EXPLAIN_CATEGORY";
